/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The MetricParamsCo2 model module.
 * @module model/MetricParamsCo2
 * @version 0.0.2
 */
export class MetricParamsCo2 {
  /**
   * Constructs a new <code>MetricParamsCo2</code>.
   * @alias module:model/MetricParamsCo2
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MetricParamsCo2</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetricParamsCo2} obj Optional instance to populate.
   * @return {module:model/MetricParamsCo2} The populated <code>MetricParamsCo2</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MetricParamsCo2();
      if (data.hasOwnProperty('gramsFixed'))
        obj.gramsFixed = ApiClient.convertToType(data['gramsFixed'], 'Number');
      if (data.hasOwnProperty('gramsPerKm'))
        obj.gramsPerKm = ApiClient.convertToType(data['gramsPerKm'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} gramsFixed
 */
MetricParamsCo2.prototype.gramsFixed = undefined;

/**
 * @member {Number} gramsPerKm
 */
MetricParamsCo2.prototype.gramsPerKm = undefined;

